import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IHomeImages, PageService, IHomeImageEntry } from 'src/app/services/page.service';
import { combineLatest, filter, finalize, map } from 'rxjs';
import {LoaderService} from '../../shared/services/loader.service';
//import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { Browser } from '@capacitor/browser';
import { ActivatedRoute,NavigationEnd,Router } from '@angular/router';
import { NotificationServiceService, INotifications } from 'src/app/store/services/notification-service.service';
import { NotificationBellServiceService } from 'src/app/store/services/notification-bell-service.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { StoreService, IStore } from '../../store/services/store.service';
import { StoreListModalComponent } from 'src/app/store/modals/store-list-modal/store-list-modal.component';
import { HomePageService } from 'src/app/services/home-page.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { IconService } from 'src/app/shared/services/icon.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { IDeliveryAddress, OrderService, PlacedOrderDisplayModel } from 'src/app/store/services/order.service';
import moment from 'moment';
import { ConfirmReorderComponent } from 'src/app/account/confirm-reorder/confirm-reorder.component';
import { IBaseBlogsRequest, IBaseNewsRequest, IBlogs, INews, NewsBlogsService } from 'src/app/shared/services/news-blogs.service';
import { MessagesComponent } from '../messages/messages.component';
import { GamesService, IBaseGameRequest, IGames } from 'src/app/shared/services/games.service';
import { GamesComponent } from 'src/app/shared/components/games/games.component';
import { ShareService } from 'src/app/shared/services/share.service';
import { AuthenticationPageComponent } from 'src/app/auth/pages/authentication-page/authentication-page.component';
import { AllInOneAuthPageComponent } from 'src/app/auth/pages/all-in-one-auth-page/all-in-one-auth-page.component';
import { AccountService, IApiAccount } from 'src/app/account/services/account.service';
//import { url } from 'inspector';

//import { SwiperComponent } from 'swiper/angular';
//import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';

//import { register } from 'swiper/element/bundle';
//register();

interface IHomePageV1imgURLs 
{
  index: number,
  imgUrldesktop: any,
  imgUrlFrdesktop: any,
  imgUrldesktopForeground: any,
  imgUrlFrdesktopForeground: any,
  imgUrlmobile: any,
  imgUrlFrmobile: any
  imgUrlmobileForeground: any,
  imgUrlFrmobileForeground: any
}

//SwiperCore.use([Navigation, Pagination, Autoplay]);

@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss'],
    standalone: false
})
export class HomePageComponent implements OnInit {
  //@ViewChild('slider', { static: false }) slider: IonSlides;
  //@ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  
  @ViewChild('swiper', { static: false }) swiperEl?: ElementRef;
  //@ViewChild('swiper', { static: false }) swiperEl?: ElementRef<HTMLDivElement>;

  @ViewChild('swiper')
  set swiperSetter(el: ElementRef) {
    if (!el) return;


    const swiper = el.nativeElement.swiper;

    if (!swiper) return;

    swiper.on('slideChange', () => {
      this.onSlideChanged();
    });

    if (swiper.autoplay) {
      
      

      if(this.setting.configuration.uIoptions?.secondsBetweenChange) {
        //dynamically change the delay between slides here ( you can also do it per slide?)

        var seconds = 5000;
        if(this.setting.configuration.uIoptions?.secondsBetweenChange > 0) {
          seconds = this.setting.configuration.uIoptions?.secondsBetweenChange;
        }

        swiper.params.autoplay.delay = seconds * 1000;
      }

      if(this.setting.configuration.uIoptions?.useCarousel) {
        swiper.update();
        swiper.autoplay.start();
      } else {
        // this is  to stop the auto play (perhaps add settings for it?)
        swiper.autoplay.stop();
      }
      


      
    }
  }

  @ViewChild('titleTextRef') titleTextRef!: ElementRef;


  //@ViewChild('notificationV1') notificationV1!: ElementRef;
  @ViewChild('notificationV1', { static: false }) notificationV1!: ElementRef<HTMLButtonElement>;

  htmlContent: SafeHtml;

  title: string = 'Nav.Home';

  
  images: IHomeImages = {
    Entries: [

    ],
    Interval: 60000
  }
  
  homePageV1imgURLs: IHomePageV1imgURLs[] = [];

  valideNotification: number;
  AllNotifications: INotifications[];

  currentSlideIndex: number = 0;

  mobile: boolean;
  currentLanguage: string;

  newsRequest: IBaseNewsRequest;
  blogsRequest: IBaseBlogsRequest;
  gamesRequest: IBaseGameRequest;

  
  //news: INews[] = [];
  //blogs: IBlogs[] = [];

  blogsCategories: IBlogs[] = [];
  newsCategories: INews[] = [];

  // group inews and i blogs together in order of dates
  newsAndBlogs: any[] = [];

  games: IGames;


  pageLoadProgress: number = 0;
  private loaderWatcher: any;

  get homeImages() {
    return {
      Interval: this.images.Interval,
      Entries: this.images.Entries
          .filter(t => t.Lang == this.translationService.getLanguage())
          .sort((a, b) => a.Position - b.Position)
      };
  }

  bellIcon: IconDefinition;

  // ----------------------------------------------------------------
  // this is going to be used for the "recent orders"
  orders: PlacedOrderDisplayModel[] = [];
  destroy: any;
  deliveryAddress: IDeliveryAddress;
  isDelivery: boolean;
  storeId: string;

  unavailableItems: any[] = [];
  unavailableOptions: any[] = [];
  changedPriceItems: any[] = [];

  change: boolean = false;
  // ----------------------------------------------------------------

  homepageContentLoaded: boolean = false;
  blogsLoaded: boolean = false;
  newsLoaded: boolean = false;
  gamesLoaded: boolean = false;
  ordersLoaded: boolean = false;
  loadedInView: boolean = false;


  primary: IApiAccount;

  constructor(
    private pageService: PageService,
              
    private loader: LoaderService,
    //private translateService: TranslateService,
    //private inAppBrowser: InAppBrowser,
    private route: ActivatedRoute,
    private router: Router,
    public NotificationService: NotificationServiceService,
    public NotificationBellService: NotificationBellServiceService,
    public setting: SettingService,
    private storeService: StoreService,
    private modalCtrl: ModalController,
    private element: ElementRef,
    public homePageService: HomePageService,
    private sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private analytics: AnalyticsService,
    private iconService: IconService,
    public translationService: TranslationService,
    public auth: AuthService,
    private orderService: OrderService,
    private newsBlogService: NewsBlogsService,
    public gamesService: GamesService,
    private shareService: ShareService,

    private accountService: AccountService
  ) {
    this.bellIcon = this.iconService.getIcon('bell')!;
    //console.log(this.bellIcon);
    document.documentElement.style.setProperty('--my-color', 'red');
  }

  async ngOnInit() {

    this.getPrimary();
    
    var currentUrl = this.getCurrentPath();
    localStorage.setItem('Stateurl', currentUrl);

    this.analytics.UpdateLocation({url: "/home", ispopup: false},  true, false);

    try {
      this.valideNotification = await this.NotificationService.notificationCount();
      this.AllNotifications = this.NotificationService.notifationArray;
    } catch (e) {
      console.log("error collecting Notification Data");
    }
    
    const language = this.route.snapshot.paramMap.get('language');
    if(language)
    {
      if(language === 'en' || language ==='fr')
        {
          localStorage.removeItem('lang');
          this.translationService.setLanguage(this.route.snapshot.params.language); 
          localStorage['lang']=this.route.snapshot.params.language
        }
        else {
          this.router.navigate(['/home'])
        }
    }
    if(this.homepageOption() == 0) {
      this.getHomeImages();
    } else {
      this.pageLoadProgress = this.pageLoadProgress + 15;
      (window as any).updateLoaderProgress(this.pageLoadProgress);
    }
    
    if(this.homepageOption() != 0) {
      this.setupImgUrls();
    } else {
      this.pageLoadProgress = this.pageLoadProgress + 15;
      (window as any).updateLoaderProgress(this.pageLoadProgress);
    }
    

    this.currentLanguage = this.translationService.getLanguage().toLowerCase();
    setInterval(() => {
      if(this.currentLanguage != this.translationService.getLanguage().toLowerCase()){
        this.currentLanguage = this.translationService.getLanguage().toLowerCase();
        this.onSlideChanged();
      }
    }, 100);


    if(window.innerWidth <= 858) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    setInterval(() => {
      if(window.innerWidth <= 858) {
        if(this.mobile != true) {
          this.mobile = true;
          this.onSlideChanged();
        }
      } else {
        if(this.mobile != false) {
          this.mobile = false;
          this.onSlideChanged();
        }
      }
    }, 100);




    if(this.homepageOption() == 10) {
      this.getAllGames();

      this.getAllNews();
      this.getAllBlogs();

      // for the card on V10 layout
      const hostElement = this.element.nativeElement;
      const host = hostElement;

      if(this.setting.configuration.uIoptions?.homePageNewsBlogColor) {
        host.style.setProperty('--blog-News-Card-Color', this.setting.configuration.uIoptions?.homePageNewsBlogColor);
      }
      if(this.setting.configuration.uIoptions?.homePageNewsBlogTextColor) {
        host.style.setProperty('--blog-News-Text-Color', this.setting.configuration.uIoptions?.homePageNewsBlogTextColor);
      }
      
    } else {
      this.pageLoadProgress = this.pageLoadProgress + 45;
      (window as any).updateLoaderProgress(this.pageLoadProgress);
    }

    if(this.auth.isAuthenticated && this.homepageOption() == 10) {
      this.getOrders();
    } else {
      this.pageLoadProgress = this.pageLoadProgress + 15;
      (window as any).updateLoaderProgress(this.pageLoadProgress);
    }


    this.loaderWatcher = setInterval(() => {

      if (this.pageLoadProgress >= 100) {
        (window as any).finishAppShell?.();
        clearInterval(this.loaderWatcher);

        this.loaderWatcher = null;
      }

    }, 100);
  }

  ngAfterViewInit() {
    //this.setting.configuration.homePageConfiguration.homePageVersion1[0]


    // this isn't working currently as the timing is off. however we have a setter element above as a @viewchile
    /*
    if(this.homepageOption() != 0 && this.swiperEl?.nativeElement) {
      //this.onSlideChanged();

      const swiperEl = this.swiperEl.nativeElement;

      swiperEl.swiper.on('slideChange', () => {
        this.onSlideChanged();
      });
    }
    */
    
    this.loadedInView = true;
    this.allLoaded();

    this.pageLoadProgress = this.pageLoadProgress + 15;
    (window as any).updateLoaderProgress(this.pageLoadProgress);
  }

  async getPrimary() {

    this.accountService.getPrimary()
      .subscribe(
        (primary) => {
          this.primary = primary;
          console.log(this.primary);
        });
  }

  allLoaded() {
    if(this.homepageContentLoaded && this.blogsLoaded && this.newsLoaded && this.gamesLoaded && this.ordersLoaded && this.loadedInView) {
      this.shareService.fullyLoaded();
    }
  }

  ionViewWillEnter() {
    if(this.auth.isAuthenticated) {
      this.getOrders();
    }
  }

  

  async setupImgUrls(){
    //console.log(this.setting.configuration.homePageConfiguration);

    if(this.setting.configuration.homePageConfiguration) {
      for(var i = 0; i < this.setting.configuration.homePageConfiguration.homePageVersion1.length; i++){
        if(this.setting.configuration.homePageConfiguration.homePageVersion1[i].desktopImageShortName){
          this.homePageV1imgURLs.push({
            index: this.setting.configuration.homePageConfiguration.homePageVersion1[i].adOrderIndex,
            imgUrldesktop: await this.homePageService.fetchImage(this.setting.configuration.homePageConfiguration.homePageVersion1[i].desktopImageShortName),
            imgUrlFrdesktop: await this.homePageService.fetchImage(this.setting.configuration.homePageConfiguration.homePageVersion1[i].desktopFrImageShortName),
            imgUrldesktopForeground: await this.homePageService.fetchImage(this.setting.configuration.homePageConfiguration.homePageVersion1[i].desktopImageShortNameForeGround),
            imgUrlFrdesktopForeground: await this.homePageService.fetchImage(this.setting.configuration.homePageConfiguration.homePageVersion1[i].desktopFrImageShortNameForeGround),
            imgUrlmobile: await this.homePageService.fetchImage(this.setting.configuration.homePageConfiguration.homePageVersion1[i].mobileImageShortName),
            imgUrlFrmobile: await this.homePageService.fetchImage(this.setting.configuration.homePageConfiguration.homePageVersion1[i].mobileFrImageShortName),
            imgUrlmobileForeground: await this.homePageService.fetchImage(this.setting.configuration.homePageConfiguration.homePageVersion1[i].mobileImageShortNameForeGround),
            imgUrlFrmobileForeground: await this.homePageService.fetchImage(this.setting.configuration.homePageConfiguration.homePageVersion1[i].mobileFrImageShortNameForeGround),
          });

        } else {
          this.homePageV1imgURLs.push({
            index: this.setting.configuration.homePageConfiguration.homePageVersion1[i].adOrderIndex,
            imgUrldesktop: "",
            imgUrlFrdesktop: "",
            imgUrldesktopForeground: "",
            imgUrlFrdesktopForeground: "",
            imgUrlmobile: "",
            imgUrlFrmobile: "",
            imgUrlmobileForeground: "",
            imgUrlFrmobileForeground: "",
          });
        }

        this.homepageContentLoaded = true;
        this.allLoaded();
        this.pageLoadProgress = this.pageLoadProgress + 15;
        (window as any).updateLoaderProgress(this.pageLoadProgress);
      }
    } 
    
  }

  async onSlideChanged() {
    if(this.setting.configuration.homePageConfiguration){
      const hostElement = this.element.nativeElement;

      if(this.homepageOption() != 10){
        const childDiv = this.titleTextRef.nativeElement.querySelector('div');
        if (childDiv) {
          this.renderer.addClass(childDiv, 'small-font');
        }
      }
      


      /*
      const index = await this.slider.getActiveIndex();
      this.currentSlideIndex = index;
    

      const page = this.setting.configuration.homePageConfiguration.homePageVersion1[index];

      if(this.mobile) {
        if (this.translateService.currentLang.toLowerCase() == 'en') {
          this.htmlContent = this.setting.configuration.homePageConfiguration.homePageVersion1[index].mobileDescriptionEN;
        } else if (this.translateService.currentLang.toLowerCase() == 'fr') {
          this.htmlContent = this.setting.configuration.homePageConfiguration.homePageVersion1[index].mobileDescriptionFR;
        }
        

        if (page) {
          const host = hostElement;
      
          host.style.setProperty('--btn-color', page.buttonColor);
          host.style.setProperty('--btn-text-color', page.buttonTextColor);
          host.style.setProperty('--btn-font-size', page.buttonTextFontSize + "px");
          host.style.setProperty('--description-color', page.desctiptionColor);
          host.style.setProperty('--description-font-size', page.desctiptionFontSize + "px");
          host.style.setProperty('--ad-slider-color', page.adSliderDotsColor);
          host.style.setProperty('--bell-overwrite-color', page.bellOverwriteColor);
        }
      } else {
        if (this.translateService.currentLang.toLowerCase() == 'en') {
          this.htmlContent = this.setting.configuration.homePageConfiguration.homePageVersion1[index].desktopDescriptionEN;
        } else if (this.translateService.currentLang.toLowerCase() == 'fr') {
          this.htmlContent = this.setting.configuration.homePageConfiguration.homePageVersion1[index].desktopDescriptionFR;
        }
        

        if (page) {
          const host = hostElement;
      
          host.style.setProperty('--btn-color', page.buttonColor);
          host.style.setProperty('--btn-text-color', page.buttonTextColor);
          host.style.setProperty('--btn-font-size', page.buttonTextFontSize + "px");
          host.style.setProperty('--description-color', page.desctiptionColor);
          host.style.setProperty('--description-font-size', page.desctiptionFontSize + "px");
          host.style.setProperty('--ad-slider-color', page.adSliderDotsColor);
          host.style.setProperty('--bell-overwrite-color', page.bellOverwriteColor);
        }
      }
        */

      const swiper = this.swiperEl?.nativeElement.swiper;

      //if (this.swiper && this.swiper.swiperRef) {
      if (swiper) {
        //const index = this.swiper.swiperRef.activeIndex;
        const index = swiper.activeIndex;
        //console.log('Active slide index:', index);

        this.currentSlideIndex = index;
    
        const page = this.setting.configuration.homePageConfiguration.homePageVersion1[index];

        if(this.mobile) {
          if (this.translationService.getLanguage().toLowerCase() == 'en') {
            this.htmlContent = this.setting.configuration.homePageConfiguration.homePageVersion1[index].mobileDescriptionEN;
          } else if (this.translationService.getLanguage().toLowerCase() == 'fr') {
            this.htmlContent = this.setting.configuration.homePageConfiguration.homePageVersion1[index].mobileDescriptionFR;
          }
          

          if (page) {
            //console.log("change styles");
            const host = hostElement;

            //console.log(page);

            host.style.setProperty('--btn-color', page.buttonColor);
            host.style.setProperty('--btn-text-color', page.buttonTextColor);
            host.style.setProperty('--btn-font-size', page.buttonTextFontSize + "px");
            host.style.setProperty('--description-color', page.desctiptionColor);
            host.style.setProperty('--description-font-size', page.desctiptionFontSize + "px");
            host.style.setProperty('--ad-slider-color', page.adSliderDotsColor);
            host.style.setProperty('--bell-overwrite-color', page.bellOverwriteColor);
          }
        } else {
          if (this.translationService.getLanguage().toLowerCase() == 'en') {
            this.htmlContent = this.setting.configuration.homePageConfiguration.homePageVersion1[index].desktopDescriptionEN;
          } else if (this.translationService.getLanguage().toLowerCase() == 'fr') {
            this.htmlContent = this.setting.configuration.homePageConfiguration.homePageVersion1[index].desktopDescriptionFR;
          }
          

          if (page) {
            //console.log("change styles 2");
            const host = hostElement;

            //console.log(page);

            host.style.setProperty('--btn-color', page.buttonColor);
            host.style.setProperty('--btn-text-color', page.buttonTextColor);
            host.style.setProperty('--btn-font-size', page.buttonTextFontSize + "px");
            host.style.setProperty('--description-color', page.desctiptionColor);
            host.style.setProperty('--description-font-size', page.desctiptionFontSize + "px");
            host.style.setProperty('--ad-slider-color', page.adSliderDotsColor);
            host.style.setProperty('--bell-overwrite-color', page.bellOverwriteColor);

          }
        }
      }
    }


    

    
  }

  getbackgroundImage(page){

    if(this.homePageV1imgURLs.length > 0) {
      if(this.homePageV1imgURLs[page.adOrderIndex]){
        if(this.mobile){
          if(this.translationService.getLanguage() == "fr"){
            if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrmobile){
              // check with anthony
              if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrmobile) {
                const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrmobile;
                return url;
              } else {
                const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrdesktop;
                return url;
              }
              
            }
          } else {
            if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlmobile){
              // check with anthony
              if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlmobile) {
                const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrlmobile;
                return url;
              } else {
                const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrldesktop;
                return url;
              }
            }
          }

        } else {
          if(this.translationService.getLanguage() == "fr"){
            if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrdesktop){
              const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrdesktop;
              return url;
            }
          } else {
            if(this.homePageV1imgURLs[page.adOrderIndex].imgUrldesktop){
              const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrldesktop;
              return url;
            }
          }
        }
        
      }
    }
  }

  HasForgroundImg(page): boolean {
    try {
      if(this.homePageV1imgURLs.length > 0) {
        if(this.homePageV1imgURLs[page.adOrderIndex]){
          if(this.mobile){
            if(this.translationService.getLanguage() == "fr"){
              if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrmobileForeground){

                const rawUrl = this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrmobileForeground?.changingThisBreaksApplicationSecurity || "";
                
                // check with anthony
                if(rawUrl.includes("assets/imgs/menu/not-found.png")) {
                  return false;
                } else {
                  return true;
                }
                
              }
            } else {
              if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlmobileForeground){

                const rawUrl = this.homePageV1imgURLs[page.adOrderIndex].imgUrlmobileForeground?.changingThisBreaksApplicationSecurity || "";
                
                // check with anthony
                if(rawUrl.includes("assets/imgs/menu/not-found.png")) {
                  return false;
                } else {
                  return true;
                }
              }
            }

            
          } else {
            if(this.translationService.getLanguage() == "fr"){
              if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrdesktopForeground){

                const rawUrl = this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrdesktopForeground?.changingThisBreaksApplicationSecurity || "";
                
                // check with anthony
                if(rawUrl.includes("assets/imgs/menu/not-found.png")) {
                  return false;
                } else {
                  return true;
                }
                
              }
            } else {
              if(this.homePageV1imgURLs[page.adOrderIndex].imgUrldesktopForeground){

                const rawUrl = this.homePageV1imgURLs[page.adOrderIndex].imgUrldesktopForeground?.changingThisBreaksApplicationSecurity || "";

                rawUrl.includes("assets/imgs/menu/not-found.png")
                // check with anthony
                if(rawUrl.includes("assets/imgs/menu/not-found.png")) {
                  return false;
                } else {
                  return true;
                }
              }
            }
          }
          
        }
      }
      
    } catch (e) {

    }
    
    return false;
  }

  getforegroundImage(page){

    if(this.homePageV1imgURLs.length > 0) {
      if(this.homePageV1imgURLs[page.adOrderIndex]){
        if(this.mobile){
          if(this.translationService.getLanguage() == "fr"){
            if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrmobileForeground){
              
              // check with anthony
              if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrmobileForeground) {
                const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrmobileForeground;
                return url;
              } else {
                const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrmobileForeground;
                return url;
              }
              
            }
          } else {
            if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlmobileForeground){

              // check with anthony
              if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlmobileForeground) {
                const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrlmobileForeground;
                return url;
              } else {
                const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrlmobileForeground;
                return url;
              }
            }
          }

          
        } else {
          if(this.translationService.getLanguage() == "fr"){
            
            if(this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrdesktopForeground){
              const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrlFrdesktopForeground;
              return url;
            }
          } else {
            
            if(this.homePageV1imgURLs[page.adOrderIndex].imgUrldesktopForeground){
              const url = this.homePageV1imgURLs[page.adOrderIndex].imgUrldesktopForeground;
              return url;
            }
          }
        }
        
      }
    }
  }

  homepageOption(): number {

    //console.log(this.setting.configuration);
    if(this.setting.configuration.uIoptions && this.setting.configuration.homePageConfiguration != null) {
      return this.setting.configuration.uIoptions?.homePageOption;
    } else {
      return 0;
    }
  }

  async openStore(storeItemUrl){
    var path = "";
    try {
      const url = new URL(storeItemUrl);
      path = url.pathname;
    } catch (e) {
      path = storeItemUrl;
    }

    const hasQueryParams = storeItemUrl.includes('?'); // confirms that there is params in the URL

    /*
    if(hasQueryParams) {
      
      const queryString = storeItemUrl.split('?')[1]; // gets the first param after the ? in the URL
      const searchParams  = new URLSearchParams(queryString);

      const params: any = {};
      searchParams.forEach((value, key) => {
        params[key] = value;
      });

      this.router.navigate([path], {
        queryParams: params
      });
      
      
    } else {
      if (path.includes('/stores/menu') && this.setting.configuration.uIoptions?.storeToPopup) {
        
        const modal = await this.modalCtrl.create({
          component: StoreListModalComponent,
          cssClass: 'store-popup-model',
          componentProps: {
            isTableOrder: false,
            disableHeader: true
          }
        });
        
        await modal.present();
  
        const { data } = await modal.onDidDismiss();
    
        if(data?.route){
          this.router.navigate(['/stores' + data.route]);
        }
          
      }else {
        this.router.navigate([path]);
      }
    }
    */
    window.location.href = storeItemUrl;

  }

  async getHomeImages() {
    const loader = await this.loader.create();
    this.pageService
      .getHomeImages()
      .pipe(finalize(async () => {
          await loader.dismiss();
      }))
      .subscribe((result) => {
        this.images = result;

        this.homepageContentLoaded = true;
        this.allLoaded();
        this.pageLoadProgress = this.pageLoadProgress + 15;
        (window as any).updateLoaderProgress(this.pageLoadProgress);
      });
  }

  stripHtml(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }

  entryUrl(entry: IHomeImageEntry) {
    //return entry.Url;
    return this.sanitizer.bypassSecurityTrustStyle(`url(${entry.Url})`);
  }

  orderOnline(e)
  {
   let button = e.target as HTMLElement;
   button.style.display = "none";
    let iframe = document.getElementById('iframe');
    iframe.style.display = "block";
  }
  
  //async entryClicked(entry: IHomeImageEntry) {
  async entryClicked(entry) {
    if (!entry.Href || entry.Href == "null")
      return;

    /*
    const browser = this.inAppBrowser.create(entry.Href, '_blank', {
      location: 'no',
    });
    */
    await Browser.open({
      url: entry.Href,
      windowName: '_blank' // opens in a new in-app browser window on mobile
    });
  }

  hasLink(image: IHomeImageEntry) {
    if (!image.Href || image.Href == "null") return false;

    return true;
  }




  /* this is for the recent orders for the page v10 */

  /*
  async getOrders() {
    //const loader = await this.loader.create();
    //await loader.present();

    
    combineLatest([
      this.orderService.findMemberAllPlacedOrder(),
      this.storeService.getStores(true, "special")
    ]).pipe(
      map(([orders,stores]) => {
          return orders.map(order => {
              let store = stores.find(store => store.id === order.storeId);
              return {
                ...order,
                storeName: store.displayName,
                storeAllowSales: store.allowSales
              }
          })
      })
    ).subscribe(orders => {
      
      combineLatest([
        this.orderService.findMemberAllPlacedOrderShipping(),
        this.storeService.getStores(true, "special")
      ]).pipe(
        finalize( () => {
          //loader.dismiss()
        }),   
        map(([ordersShipping,stores]) => {
            return ordersShipping.map(orderShipping => {
              let store = stores.find(store=>store.id === orderShipping.storeId);
              return {
                ...orderShipping,
                storeName: store.displayName,
                storeAllowSales: store.allowSales
              }
            })
        })
      ).subscribe(ordersShipping => {
        let allOrders = orders.concat(ordersShipping);
        this.orders = allOrders.sort((a, b) => {
          let aDate: moment.Moment = moment(a.date);
          let bDate: moment.Moment = moment(b.date);
          return bDate.diff(aDate);
        });

        this.ordersLoaded = true;
        this.allLoaded();

        this.pageLoadProgress = this.pageLoadProgress + 15;
        (window as any).updateLoaderProgress(this.pageLoadProgress);
      })
    });
  }
  */

  async getOrders() {
    //const loader = await this.loaderService.create();
    //await loader.present();
    combineLatest([
      this.orderService.findMemberAllPlacedOrder(),
      this.storeService.getStores(true)
    ]).pipe(
      map(([orders, stores]) => {

          return orders.map(order => {
              let store = stores.find(store => store.id === order.storeId);
              return {
                ...order,
                storeName: store.displayName,
                storeAllowSales: store.allowSales
              }
          })
      })
    ).subscribe(orders => {
      combineLatest([
        this.orderService.findMemberAllPlacedOrderShipping(),
        this.storeService.getStores(true)
      ]).pipe(
        finalize(() => {
          //loader.dismiss()
        }),   
        map(([ordersShipping, stores]) => {

          /*
          return ordersShipping.map(orderShipping => {
            let store = stores.find(store => store.id === orderShipping.storeId);
            return {
              ...orderShipping,
              storeName: store?.displayName,
              storeAllowSales: store?.allowSales
            }
          })
            */

          const storeMap = new Map(stores.map(s => [s.id, s]));

          return ordersShipping
            .filter(orderShipping => storeMap.has(orderShipping.storeId)) // remove invalid ones
            .map(orderShipping => {
              const store = storeMap.get(orderShipping.storeId)!;

              return {
                ...orderShipping,
                storeName: store.displayName,
                storeAllowSales: store.allowSales
              };
          });
        })
      ).subscribe(ordersShipping => {

        let allOrders = orders.concat(ordersShipping);

        this.orders = allOrders.sort((a, b) => {
          let aDate: moment.Moment = moment(a.date);
          let bDate: moment.Moment = moment(b.date);
          return bDate.diff(aDate);
        });

        this.pageLoadProgress = this.pageLoadProgress + 15;
        (window as any).updateLoaderProgress(this.pageLoadProgress);
      })
    });

    
  }

  async reOrder(pastOrder: PlacedOrderDisplayModel) { 
  
    /*
    if(this.isPopup) {
      this.modalCtrl.dismiss();  
    }
    */
    
  
    const loader = await this.loader.create();
    await loader.present();
  
    //later check something more suitable 
    this.destroy = this.storeService.getMenu(pastOrder.storeId,undefined,undefined)
    .pipe(finalize( () => {
      loader.dismiss()
    }), map(data => {
      return data.storeMenuCategories.map(item1 => {
        return item1.storeMenuCategoryItems.map(item2 => {
             return({ itemOptionCategories: item2.item.itemOptionCategories,
                      name: item2.item.itemName,
                      itemId: item2.item.id,
                      price: item2.item.price,
                      taxEligible: item2.item.taxEligible, //missing
                      itemDetailCombination: item2.item.itemDetailCombination ? item2.item.itemDetailCombination : null,
                      colors: item2.item.itemColors,
                      sizes: item2.item.itemSizes,
                      quantity: item2.item.quantity,
                      isInventoryExist: item2.item.isInventoryExist,
                      isInventoryActive: item2.item.isInventoryActive,
                      _hidePrice: false,
                      isDelivery: item2.item.isDelivery,
                      itemAvailableHour: item2.item.itemAvailableHour,
                      isActive: item2.item.isActive})  
            })
       })
    }))
    .subscribe(menu => {
      let mergedMenu = [];
  
      for(let i = 0; i < menu.length; i++)
      {
        mergedMenu = mergedMenu.concat(menu[i]);
      }
  
      this.orderService.findPlacedOrderById(pastOrder.orderId)
      .pipe(map(data => {
        this.isDelivery = data.isDelivery;
        this.deliveryAddress = data.deliveryAddress;
        this.storeId = data.storeId;
        //p start
        return data.items.map(p => { 
          let item = mergedMenu.filter(item => item.itemId == p.id); //we need id on ordered products
          let originalItem = item[0];
          if(!originalItem)
          {
            this.unavailableItems.push(p);
            return;
          }
          if(p.itemDetailCombination)
          {
            let itemColor=originalItem.colors.find(item => item.id == p.itemDetailCombination.colorId);
            let itemSize=originalItem.sizes.find(item =>item.id == p.itemDetailCombination.sizeId);
            if(!itemColor || !itemSize)
            {
              this.unavailableItems.push(p);
              return;
            }
          }
          if(!originalItem.isActive){
            this.unavailableItems.push(p);
            return;
          } 
          if((originalItem.isInventoryExist && originalItem.isInventoryActive))
          {
            if(originalItem.quantity == 0)
            {
              this.unavailableItems.push(p);
              return;
            }
          } 
  
          p.options.map(option1 => {
        
              originalItem.itemOptionCategories.map(menu => {
                if(option1.id != null){
                  let originalOption = menu.options.find(option => option.optionId == option1.id);//ask about ID and also about that sometimes items don't have name
                  if(originalOption)
                  {
                    option1.optionId = option1.id;
                    option1.name = originalOption.option.name;
                    option1.itemOptionCategoryId = menu.id;
                    if(option1.price!=originalOption.option.price) 
                    { 
                      this.change = true;
                      option1.price = originalOption.option.price;
                    }
                  }
                } else if (option1.itemId != null){
                  for(let option of menu.options){
                    if(option.option && option.option.categoryItems && option.option.categoryItems.length > 0){
                      let originalOption = option.option.categoryItems.find(item => item.itemId == option1.itemId);//ask about ID and also about that sometimes items don't have name
                      if(originalOption)
                      {
                        option1.optionId = null;
                        option1.name = originalOption.name;
                        option1.itemNumber = originalOption.itemNumber;
                        option1.itemOptionCategoryId = menu.id;
                        if(option1.price!=originalOption.price) 
                        { 
                          this.change = true;
                          option1.price=originalOption.price;
                        }
                      }
                    }
                  }
                }
              })
              
          });
  
          if(originalItem.itemDetailCombination && p.itemDetailCombination)
          {
            originalItem.itemDetailCombination.map(item => {
            
              if(item.id == p.itemDetailCombination.id)
              {
                if(item.price !== p.itemDetailCombination.price || item.code !== p.itemDetailCombination.code )//item.sizeId !==p.itemDetailCombination.sizeId || item.colorId !== p.itemDetailCombination.colorId
                {
                  p.itemDetailCombination.price=item.price;
                  this.change = true;
                }
              }
            });
          }
          if(originalItem.price == p.price)
          { 
            return {
              itemId: originalItem.itemId,
              itemName: originalItem.name, 
              itemNumber: p.itemNumber,
              options: p.options, 
              taxEligible: originalItem.taxEligible, //missing
              price:  p.itemDetailCombination ? p.itemDetailCombination.price : originalItem.price, //p.totalPrice cannot use p.price,
              quantity: p.quantity,
              allergies: p.allergies,
              note: p.note,
              _chainItemId: null, //missing
              _hidePrice: false, //linked to override price,
              itemDetailCombination: p.itemDetailCombination,
              itemAvailableHour: originalItem.itemAvailableHour,
              isDelivery: originalItem.isDelivery,
              orderType: this.isDelivery ? "delivery" : "pickup"
            }
          }
          else if(originalItem.price != p.price){ 
            this.change = true;
            if(!this.changedPriceItems.some(item => item.itemId == p.id)){
              this.changedPriceItems.push({
                itemId: p.id,
                itemName: p.name,
                oldPrice: p.price,
                newPrice: originalItem.price
              });
            }
            return {
              itemId: originalItem.itemId,
              itemName: originalItem.name, 
              itemNumber: p.itemNumber,
              options: p.options, 
              taxEligible: originalItem.taxEligible, //missing
              price: p.itemDetailCombination ? p.itemDetailCombination.price : originalItem.price, //p.totalPrice cannot use p.price,
              quantity: p.quantity,
              allergies: p.allergies,
              note: p.note,
              _chainItemId: null, //missing
              _hidePrice: false, //linked to override price,
              itemDetailCombination: p.itemDetailCombination,
              itemAvailableHour: originalItem.itemAvailableHour,
              isDelivery: originalItem.isDelivery,
              orderType: this.isDelivery ? "delivery" : "pickup"
            }
          }                                               
        })
      }))
      .subscribe((order) => {
        order = order.filter(i => i != undefined);
        if(order.length == 0)
        {
          this.modalCtrl.create({
            component: ConfirmReorderComponent,
            componentProps: {
              noItem: true
            },
            cssClass: 'my-custom-modal-css3'
          }).then(modalres => {
            modalres.present();
            this.resetValues();
          });
          return;
        }
        if(this.unavailableItems.length > 0)
        {
          this.modalCtrl.create({
            component: ConfirmReorderComponent,
            cssClass: 'my-custom-modal-css4',
            componentProps: {
              item: order,
              unavailableItems: this.unavailableItems,
              changedPriceItems: this.changedPriceItems,
              change: this.change,
              storeId: this.storeId,
              orderType: this.isDelivery ? 'delivery' : 'pickup',
              deliveryAddress: this.deliveryAddress
            }
            }).then(modalres => {
              modalres.present();  
              this.resetValues();
            });
          return;
        }
  
        if(!this.change){
          this.modalCtrl.create({
            component: ConfirmReorderComponent,
            componentProps: {
              item: order,
              change: this.change,
              storeId: this.storeId,
              orderType: this.isDelivery ? 'delivery' : 'pickup',
              deliveryAddress: this.deliveryAddress
            },
            cssClass: 'my-custom-modal-css4'
          }).then(modalres => {
            modalres.present();
            this.resetValues();
          });
        }
        else { 
          this.modalCtrl.create({
            component: ConfirmReorderComponent,
            componentProps: {
              item: order,
              change: this.change,
              storeId: this.storeId,
              orderType: this.isDelivery ? 'delivery' : 'pickup',
              changedPriceItems: this.changedPriceItems,
              deliveryAddress: this.deliveryAddress
            },
            cssClass: 'my-custom-modal-css4'
          }).then(modalres => {
            modalres.present();
            this.resetValues();
          });
        }
      })
    })
    
  }
  
  resetValues(){
    this.unavailableItems = [];
    this.unavailableOptions = [];
    this.changedPriceItems = [];
  }

  detail(id: string, isShipping: boolean) { 

    /*
    if(this.isPopup) {
      this.modalController.dismiss(); 
    }
    */

    this.pageService.getDetails(true);
    if(isShipping){
      this.router.navigateByUrl(`/shipping/tracking/${id}`); 
    } else {
      this.router.navigateByUrl(`/order/tracking/${id}`);
    }
  }

  getCurrentPath(): string {
    return this.router.url;
  }

  async goToLogin() {
    // save the current Url first

    var currentUrl = this.getCurrentPath();
    localStorage.setItem('Stateurl', currentUrl);

    if(this.setting.configuration.uIoptions?.loginToPopup) {
      if(this.setting.configuration.uIoptions?.allinOneAuthPage) {
        // prevents crash if the undocked navbar is inside a popup
        const modal = await this.modalCtrl.create({
          component: AllInOneAuthPageComponent,
          cssClass: 'auth-popup-model',
          componentProps: {
            disableHeader: true,
            isPopup: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      } else {
        // prevents crash if the undocked navbar is inside a popup
        const modal = await this.modalCtrl.create({
          component: AuthenticationPageComponent,
          cssClass: 'auth-popup-model',
          componentProps: {
            disableHeader: true
          }
        });
      
        modal.onWillDismiss()
          .then((result) => {
            
        });
      
        await modal.present();
      }
      return;
    } else {
      if(this.setting.configuration.uIoptions?.allinOneAuthPage) { 
        this.router.navigate(['auth/fullauth']);
      } else {
        this.router.navigate(['auth']);
      }
      return;
    }
  }

  async openMessages() {
    // i'll have the popup version and the page option here (starting with the model)


    /*
    const modal = await this.modalCtrl.create({
      component: MessagesComponent,
      cssClass: 'Messages-popup-model',
      //componentProps: { disableHeader: true }
    });
  
    modal.onWillDismiss()
      .then((result) => {
        
    });
  
    await modal.present();
    */


    this.router.navigate(['/messages']);
  }

  async startGame() {
    if(!this.gamesService.games) {
      return;
    }

    if(this.auth.isAuthenticated) {
      const modal = await this.modalCtrl.create({
        component: GamesComponent,
        cssClass: 'game-popup',
        componentProps: {
          games: this.games
        }
      });
    
      modal.onWillDismiss()
        .then((result) => {
          
      });
    
      await modal.present();
    } else {
      this.goToLogin();
    }
    
  }

  getAllGames(){
    this.fetchGames().subscribe(async Games => {
      this.games = Games;
      
      //console.log(Games);

      // add the styles here:
      if(Games) {
        if(Games.homePagePlayBtnColorGradient1 && Games.homePagePlayBtnColorGradient2) {
          const hostElement = this.element.nativeElement;
          const host = hostElement;
          host.style.setProperty('--play-btn-gradient1', Games.homePagePlayBtnColorGradient1);
          host.style.setProperty('--play-btn-gradient2', Games.homePagePlayBtnColorGradient2);
        }
      }

      this.gamesLoaded = true;
      this.allLoaded();
      this.pageLoadProgress = this.pageLoadProgress + 15;
      (window as any).updateLoaderProgress(this.pageLoadProgress);
    });
  }

  fetchGames() {
    this.gamesRequest = {
      merchantId: this.setting.getMerchantId()
    }

    return this.gamesService.getGames(this.gamesRequest);
  }


  getAllNews(){
    this.fetchNews().subscribe(async newsCat => {

      this.newsCategories = newsCat;

      for(var i = 0; i < this.newsCategories.length; i++) {
        var category = this.newsCategories[i];

        for(var y = 0; y < category.news.length; y++) {
          var news = category.news[y];

          news.images['imgURL'] = await this.newsBlogService.fetchImage(news.images.imgShortName);
          news.images['imgMobileURL'] = await this.newsBlogService.fetchImage(news);


          const newNews = {
            ...news,
            isNews: true,
            isBlogs: false
          };
          this.newsAndBlogs.push(newNews);
          
        }
      }

      //console.log(this.newsAndBlogs);

      this.newsLoaded = true;
      this.allLoaded();

      this.changeOrderNewsBlog();

      this.pageLoadProgress = this.pageLoadProgress + 15;
      (window as any).updateLoaderProgress(this.pageLoadProgress);
    });
  }

  fetchNews() {
    if(this.auth.isAuthenticated) {
      this.newsRequest = {
        merchantId: this.setting.getMerchantId(),
        userId: this.auth.memberId.toString()
      }
    } else {
      this.newsRequest = {
        merchantId: this.setting.getMerchantId(),
        userId: ""
      }
    }

    return this.newsBlogService.getNews(this.newsRequest);
  }

  getAllBlogs(){
    this.fetchBlogs().subscribe(async blogs => {
      /*
      this.blogs = [];

      this.blogs = blogs;
      
      
      for(var i = 0; i < blogs.length; i++){
        // inject the image URL in each promotions
        this.blogs[i].images['imgURL'] = await this.newsBlogService.fetchImage(blogs[i].images.imgShortName);
        this.blogs[i].images['imgMobileURL'] = await this.newsBlogService.fetchImage(blogs[i].images.imgMobileShortName);
      }
      */

      this.blogsCategories = blogs;

      for(var i = 0; i < this.blogsCategories.length; i++) {
        var category = this.blogsCategories[i];

        for(var y = 0; y < category.blogs.length; y++) {
          var blog = category.blogs[y];

          blog.images['imgURL'] = await this.newsBlogService.fetchImage(blog.images.imgShortName);
          blog.images['imgMobileURL'] = await this.newsBlogService.fetchImage(blog.images.imgMobileShortName);


          const newBlogs = {
            ...blog,
            isNews: false,
            isBlogs: true
          };
          this.newsAndBlogs.push(newBlogs);
        }
      }

      this.blogsLoaded = true;
      this.allLoaded();

      /*
      for(var i = 0; i < blogs.length; i++){
        const newBlogs = {
          ...this.blogs[i],
          isNews: false,
          isBlogs: true
        };
        this.newsAndBlogs.push(newBlogs);
      }
      */
      this.changeOrderNewsBlog();

      this.pageLoadProgress = this.pageLoadProgress + 15;
      (window as any).updateLoaderProgress(this.pageLoadProgress);
    });
  }

  fetchBlogs() {
    if(this.auth.isAuthenticated) {
      this.blogsRequest = {
        merchantId: this.setting.getMerchantId(),
        userId: this.auth.memberId.toString()
      }
    } else {
      this.blogsRequest = {
        merchantId: this.setting.getMerchantId(),
        userId: ""
      }
    }
    
    return this.newsBlogService.getBlogs(this.blogsRequest);
  }

  changeOrderNewsBlog(){
    this.newsAndBlogs.sort((a, b) => {
      return new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime();
    })
  }

  getnewsImage(news){
    /*
    if(news.images){
      if(news.images.imgURL) {
        //const url = news.images.imgURL;
        const url = news.images.imgMobileURL;
        return url;
      }     
    }
    */

    //smaImage
    if (news.images.imgMobileShortName == null && news.images.imgMobileDisplayName) {
      const urlPath = news.images.imgMobileDisplayName;
      return "https://seemyapps.com" + urlPath;
    } else {
      //SMS image
      if(news.images){
        if(news.images.imgMobileURL) {
          const url = news.images.imgMobileURL;
          return url;
        }     
      }
    }
  }

  getblogsImage(blogs){
    /*
    if(blogs.images){
      if(blogs.images.imgMobileURL) {
        //const url = blogs.images.imgURL;
        const url = blogs.images.imgMobileURL;
        return url;
      }     
    }
      */

    if (blogs.images.imgMobileShortName == null && blogs.images.imgMobileDisplayName) {
      const urlPath = blogs.images.imgMobileDisplayName;
      return "https://seemyapps.com" + urlPath;
    } else {
      //SMS image
      if(blogs.images){
        if(blogs.images.imgMobileURL) {
          const url = blogs.images.imgMobileURL;
          return url;
        }     
      }
    }
  }

}
